import { useQuery } from '@tanstack/react-query';
import type { PromotionPolicyToken } from '@sleed/bizcommerce-api';
import { promotionPoliciesApi } from '~/lib/api/client';
import { promotionKeys } from '~/hooks/use-promotion';

export interface PromotionsListParams {
	skip?: number;
	take?: number;
}

export interface PromotionsListResult {
	items: PromotionPolicyToken[];
	totalCount: number;
}

/**
 * Paginated policy list via the DevExtreme `loadOptions` envelope (matches the
 * legacy admin's `promotionpolicies/query`). Returns raw tokens — the grid is
 * display-only and reads token fields directly.
 */
export function usePromotionsList(params: PromotionsListParams = {}) {
	const { skip = 0, take = 25 } = params;
	return useQuery<PromotionsListResult>({
		queryKey: promotionKeys.list({ skip, take }),
		queryFn: async () => {
			const res = await promotionPoliciesApi.query({
				loadOptions: { skip, take, requireTotalCount: true }
			});
			return {
				items: res.data.data ?? [],
				totalCount: res.data.totalCount ?? 0
			};
		}
	});
}
